import { createUseStyles } from 'react-jss';
export default createUseStyles((theme) => ({
    container: {
        position: 'absolute',
        zIndex: 1000,
        boxShadow: theme.elevation.menu,
        backgroundColor: 'white',
        borderRadius: 4,
        '&::-webkit-scrollbar': { width: 0 },
        scrollbarWidth: 0,
        overflowX: 'hidden'
    }
}));
//# sourceMappingURL=styles.js.map